module.exports = __webpack_public_path__ + "left.3ZKA_2m0.svg";